export default {
  methods: {
    generateVigilanceStatusClass (status) {
      let ret = false

      if (status === "reinforced")
        ret = "red"
      else if (status === "complementary")
        ret = "orange"

      return ret
    },

    decodeCustomerSapGroup (group) {
      let ret = ""

      if (group === "GA")
        ret = "Entreprise"
      else if (group === "GB")
        ret = "Association"
      else if (group === "GC")
        ret = "Association à but humanitaire"

      return ret
    },

    decodeBrands (brands) {
      return _.chain(brands).map('name').value()
    }
  },

  computed: {
    vigilanceStatusClass () {
      const status = this.customer.vigilance_status

      return this.generateVigilanceStatusClass(status)
    },

    showVigilance () {
      return this.vigilanceStatusClass
    },

    customerEntity () {
      return this.decodeCustomerSapGroup(this.customer.customer_sap_group)
    },

    lastSirenUpdate() {
      // On filtre d'abord les activités du type "siren-update"
      const updates = _.filter(this.customer.activity_log, { type: 'siren-update' })
      
      // Si aucune activité trouvée → on retourne null
      if (_.isEmpty(updates)) {
        return null
      }

      // On trie par date décroissante (la plus récente en premier)
      // en supposant que chaque activité contient une propriété 'date' ou 'created_at'
      const sorted = _.orderBy(updates, ['created_at'], ['desc'])

      // On retourne la première (la plus récente)
      return _.first(sorted)
    }
  }
}



// WEBPACK FOOTER //
// ./client/mixins/customer.js